import type { FormSlotPickerProps } from '../types';
import type { FieldValues } from 'react-hook-form';

import { SlotPicker } from '@/components/SlotPicker';

import { FormFieldShell } from '../FormFieldShell';

export const FormSlotPicker = <TFieldValues extends FieldValues = FieldValues>(
  props: FormSlotPickerProps<TFieldValues>,
) => {
  const {
    name,
    label,
    description,
    isRequired,
    slots,
    isLoading,
    placeholder,
    isInvalid,
  } = props;

  return (
    <FormFieldShell
      name={name}
      description={description}
      render={({ field, fieldState }) => (
        <SlotPicker
          label={label}
          isRequired={isRequired}
          slots={slots}
          value={field.value || null}
          isLoading={isLoading}
          placeholder={placeholder}
          isInvalid={isInvalid || fieldState.invalid}
          onChange={field.onChange}
        />
      )}
    />
  );
};
